import { createContextualCan } from '@casl/react';
import { createContext } from 'react';

import { buildAbilityFor } from '@acl/config';

export const AbilityContext = createContext(buildAbilityFor());
export const Can = createContextualCan(AbilityContext.Consumer);

export default buildAbilityFor();
